import React, { useEffect, useLayoutEffect, useRef } from "react"
// import { useForm } from "react-hook-form"
// import * as css from "@css/projects/p-form.module.styl"
import { useRecoilState } from 'recoil'
import { userLoginState } from "@status/UserState"
import { isBrowser } from "../../services/auth"
import { useTransition } from "../layouts/TransitionLayout"


{/* 埋め込みコード例
<button class="button custom-embed"
    data-action="https://zaiko.io/buy/unlock"
    data-item="1AlI:Rx:3c8e2"
    data-profile="l-tike"
    data-password-event="cxdtgbuy"
>
    お申し込みはこちら
</button>

data属性の命名規則:
- data-action: フォームの送信先URL（必須、許可されたドメインのみ）
- その他のdata属性: 属性名がそのままフォームフィールド名になります
  - data-item → name="item"
  - data-profile → name="profile"
  - data-password-event → name="password[event]" (ハイフンはブラケット記法に変換)

セキュリティ:
- 許可されたドメインのみ送信可能（ホワイトリスト）
- HTTPSのみ許可
- フィールド名は英数字、ハイフン、ブラケットのみ許可
*/}

// 許可されたドメインのホワイトリスト
const ALLOWED_DOMAINS = [
    'zaiko.io',
    'va.pia.jp',
    'l-tike.com',
    // 必要に応じて追加
];

export default function EmbedCustom({
    isButton
}){
    const return_url = "https://fcrabupi.shirota-yu.com/500"
    const formRef = useRef()
    const [userLogin, setUserLogin] = useRecoilState(userLoginState)
    const { setTranstionState } = useTransition()
    
    // URLの検証（HTTPSのみ、許可されたドメインのみ）
    const validateUrl = (url) => {
        if (!url) return false;
        
        try {
            const urlObj = new URL(url);
            
            // HTTPSのみ許可
            if (urlObj.protocol !== 'https:') {
                console.warn('EmbedCustom: HTTPSのみ許可されています', url);
                return false;
            }
            
            // 許可されたドメインかチェック
            const hostname = urlObj.hostname.toLowerCase();
            const isAllowed = ALLOWED_DOMAINS.some(domain => 
                hostname === domain || hostname.endsWith('.' + domain)
            );
            
            if (!isAllowed) {
                console.warn('EmbedCustom: 許可されていないドメインです', hostname);
                return false;
            }
            
            return true;
        } catch (e) {
            console.warn('EmbedCustom: 無効なURLです', url);
            return false;
        }
    }
    
    // フィールド名のサニタイゼーション（英数字、ハイフン、ブラケットのみ許可）
    const sanitizeFieldName = (name) => {
        // 英数字、ハイフン、ブラケット、アンダースコアのみ許可
        return name.replace(/[^a-zA-Z0-9\-\[\]_]/g, '');
    }
    
    // data属性名をフォームフィールド名に変換
    // 例: password-event → password[event]
    const convertDataNameToFieldName = (dataName) => {
        // まずサニタイゼーション
        const sanitized = sanitizeFieldName(dataName);
        
        // ハイフンで区切られた部分を配列に分割
        const parts = sanitized.split('-');
        if (parts.length === 1) {
            return sanitized;
        }
        // 最初の部分をそのまま、残りをブラケット記法に変換
        return `${parts[0]}[${parts.slice(1).join('][')}]`;
    }
    
    useLayoutEffect( () => {
        console.log("btn=>","setup");
    },[userLogin])

    useEffect( ()=>{
        if( !isBrowser() || !userLogin ) return
        ( async ()=>{
            const buttons = document.getElementsByClassName('custom-embed')
            for(let i = 0; i < buttons.length; i ++){
                let btn = buttons[i]
                btn.classList.remove("button-disable")
                btn.classList.add("button")
                btn.addEventListener('click',(e)=>{
                    e.preventDefault();
                    ( async ()=>{
                        const data = e.target.dataset;
                        
                        // action URLを検証して設定（必須）
                        if (!data.action) {
                            console.error('EmbedCustom: data-action属性が指定されていません');
                            return;
                        }
                        
                        if (!validateUrl(data.action)) {
                            console.error('EmbedCustom: 無効なURLです', data.action);
                            return;
                        }
                        
                        formRef.current.action = data.action;
                        
                        // すべてのdata属性をinputフィールドとして処理
                        Object.keys(data).forEach(key => {
                            // actionはフォームのaction属性なのでスキップ
                            if (key === 'action') return;
                            
                            const fieldName = convertDataNameToFieldName(key);
                            
                            // フィールド名が空の場合はスキップ
                            if (!fieldName) {
                                console.warn('EmbedCustom: 無効なフィールド名です', key);
                                return;
                            }
                            
                            const fieldValue = data[key];
                            
                            // 既存のinputフィールドを探す
                            let input = formRef.current.querySelector(`input[name="${fieldName}"]`);
                            
                            if (!input) {
                                // 存在しない場合は新規作成
                                input = document.createElement('input');
                                input.type = 'hidden';
                                input.name = fieldName;
                                input.id = `custom-${fieldName.replace(/[\[\]]/g, '-')}`;
                                formRef.current.appendChild(input);
                            }
                            
                            // 値を設定（DOM APIにより自動的にエスケープされる）
                            input.value = fieldValue || '';
                        });
                        
                        formRef.current.target = 'new_window'
                        formRef.current.submit();
                    } )()

                })
            }
        } )()
        console.log("btn=>","ok")
    },[userLogin])

    return(
        <>
        <form method="POST" ref={formRef}>
            {/* 動的にinputフィールドが生成されます */}
            { isButton && <input type="submit" value="Go To Event"/> }
        </form>
        </>
    )
}
